import { createBrowserHistory } from 'history';
const { REACT_APP_BASE_NAME } = process.env;

const history = createBrowserHistory({ basename: REACT_APP_BASE_NAME })

export default history